export const OTHERS_CATEGORY_NAME = 'Others';

// 'RANKING' orders the data by value and 'FIXED' keeps the order present in the original data
export const ORDER_TYPES = {
  RANKING: 'ranking',
  FIXED: 'fixed'
};
